import classNames from "classnames";
import "./style.css";

export enum TooltipTextPosition {
    Top = "TOP",
    Bottom = "BOTTOM",
    Left = "LEFT",
}

interface TooltipProps {
    children: any;
    text: any;
    position?: TooltipTextPosition;
    hasSmallChildren?: boolean;
}

const Tooltip = ({
    children,
    hasSmallChildren,
    position,
    text,
}: TooltipProps) => (
    <div
        className={classNames(
            "c-Tooltip-container",
            position === TooltipTextPosition.Top
                ? "c-Tooltip-container-top"
                : position === TooltipTextPosition.Bottom
                ? "c-Tooltip-container-bottom"
                : "c-Tooltip-container-left"
        )}
    >
        {children}
        <div
            className={
                position === TooltipTextPosition.Top
                    ? "c-Tooltip-text-top"
                    : position === TooltipTextPosition.Bottom
                    ? "c-Tooltip-text-bottom"
                    : hasSmallChildren
                    ? "c-Tooltip-text-left c-Tooltip-text-left-small-children"
                    : "c-Tooltip-text-left"
            }
        >
            {text}
        </div>
    </div>
);

export default Tooltip;
